<template>
  <div class="container top-up">
    <payment-headline :title="$t('payment.topUp.title')" :description="$t('payment.topUp.description')"/>
    <payment-form :submitBtn="$t('payment.topUp.pay')"
                  :payment-form="paymentForm"
                  :show-modal="showModal"
                  ref="topUp"
                  @submitted="paymentSubmitted = $event"
                  @form-is-valid="submitBillPayment">
      <base-v-input v-model="phone"
                    variant="white"
                    :label="$t('form.phoneNumber')"
                    :submitted="paymentSubmitted"
                    rules="required|phoneNumberWithSpaces|max:15"
                    :maxlength="(13 + countSpecialChars).toString()"/>
      <base-v-input v-model="email"
                    :label="$t('form.emailAddress')"
                    :submitted="paymentSubmitted"
                    variant="white"
                    rules="required|email"/>
      <div class="amount-container">
        <base-v-input v-model.trim="amount"
                      :label="$t('form.amount')"
                      :submitted="paymentSubmitted"
                      variant="white"
                      class="amount-container"
                      rules="required|currencyRangeWithComma:3,50|max:5"
                      maxlength="5"/>
        <span id="euro">&euro;</span>
      </div>
    </payment-form>
  </div>
</template>

<script>
import PaymentHeadline from '@/components/payment/payment-headline'
import PaymentForm from '@/components/payment/payment-form'
import BaseVInput from '@/components/base/base-v-input'
import { topUp } from '@/api/payment'
import { getUrlParam } from '@/utils/urlMethods'
import errorMessageHandler from '@/mixins/errorMessageHandler'
import { englishLanguage } from '@/config/constants'

// TODO: use one component instead of two (view-top-up and view-top-up-english) with props for language
export default {
  name: 'view-bill-payment',
  mixins: [errorMessageHandler],
  components: { PaymentHeadline, PaymentForm, BaseVInput },
  data () {
    return {
      phone: '',
      email: '',
      amount: '',
      showModal: false,
      paymentForm: {},
      paymentSubmitted: false,
      toastMessage: Object.freeze({
        success: {
          status: 'success',
          title: this.$t('payment.topUp.successfulTopUp')
        },
        'payment-failed': {
          status: 'error',
          title: this.$t('payment.error.title'),
          message: this.$t('payment.error.message')
        }
      })
    }
  },
  created () {
    this.$i18n.locale = englishLanguage
    this.showToastMessage()
  },
  computed: {
    countSpecialChars () {
      if (this.phone.startsWith('00')) {
        return Math.min(this.phone.replace(/[0-9a-zA-Z]/g, '').length + 2, 5)
      }
      return Math.min(this.phone.replace(/[0-9a-zA-Z]/g, '').length, 5)
    }
  },
  methods: {
    submitBillPayment () {
      this.showModal = true
      const normalizedNumber = this.phone.replace(/[^0-9]/g, '')
      const normalizeAmount = this.amount.replace(',', '.')
      const dataToSend = {
        toMsisdn: normalizedNumber,
        email: this.email,
        amount: normalizeAmount
      }
      topUp(dataToSend).then(response => {
        this.paymentForm = response.data || {}
        setTimeout(() => {
          this.$refs.topUp.$refs.bankForm.submitForm()
        }, 50)
      }).catch(e => {
        this.showModal = false
        this.handleErrorMessage(e.response.data)
      })
    },
    showToastMessage () {
      const status = getUrlParam('status')
      if (status && this.toastMessage[status]) {
        setTimeout(() => {
          this.toast(this.toastMessage[status].status, {
            title: this.toastMessage[status].title,
            message: this.toastMessage[status].message
          })
        }, 500)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.top-up {
  padding-top: 2rem;
  padding-bottom: 2rem;
  @media (map_get($breakpoints, md)) {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  @media (map_get($breakpoints, lg)) {
    padding-top: 10rem;
  }

  @media (map_get($breakpoints, xl)) {
    padding-top: 6rem;
  }

  .amount-container {
    width: 100%;
    position: relative;
    #euro {
      position: absolute;
      top: 36px;
      font-size: 20px;
      right: 10px;
    }
  }
}
</style>

<style lang="scss" scoped>
.top-up {
  padding-top: 2rem;
  padding-bottom: 2rem;
  @media (map_get($breakpoints, md)) {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  @media (map_get($breakpoints, lg)) {
    padding-top: 10rem;
  }

  @media (map_get($breakpoints, xl)) {
    padding-top: 6rem;
  }

  .amount-container {
    width: 100%;
    position: relative;
    #euro {
      position: absolute;
      top: 36px;
      font-size: 20px;
      right: 10px;
    }
  }
}
</style>
